import * as React from "react";
import moment from "moment";

import { CurrentUserResponse, EventTimes as IEventTimes, TranslatedContent } from "../../../models";

import DateRangeOutlinedIcon from "@mui/icons-material/DateRangeOutlined";
import { formatDate, isAllDayEvent } from "utils/dateFormatting";
import IconField from "modules/common/components/iconField/iconField";


class EventTimes extends React.Component<IEventTimesProps> {
  public componentDidMount() {
    moment.locale("en");
  }

  public render() {
    const { eventTimes } = this.props;
    const startTimes: string[] = Object.keys(eventTimes);
    const isMultiDay: boolean = startTimes.length > 1;
    const hasSpecificTimes: boolean = isMultiDay && startTimes.findIndex(startTime => !!eventTimes[startTime]) !== -1;

    return <IconField icon={<DateRangeOutlinedIcon fontSize="small" className="event-times-icon"/>}>
      <div className={isMultiDay ? "multi-day-event-times" : ""}>
        {
          startTimes.map((startTime, index) => {
            let isAllDay = isAllDayEvent(eventTimes, startTime);
            
            return <div key={index}>
                <span className="event-times-day">{`${isMultiDay ? `Day ${index + 1} - ` : ""}${isAllDay ? formatDate(new Date(startTime), isAllDay, true) : moment(startTime).format("ddd, MMM D, YYYY")}, `}</span>
                <span className={hasSpecificTimes ? "event-times-time" : ""}>
                  {
                    !eventTimes[startTime]
                      ? `All Day`
                      : `${moment(startTime).format("h:mm A")} - ${moment(eventTimes[startTime]!).format("h:mm A")}`
                  }
                </span>
              </div>;
            }
          )
        }
      </div>
    </IconField>;
  }
}


interface IEventTimesProps {
  activeLcid: string;
  eventTimes: IEventTimes;
  isCurrentUserAttending?: boolean;
  location?: string;
  locationLink?: string;
  locationLinkLabel?: string;
  respondingEnabled?: boolean;
  translatedContent: TranslatedContent;
  currentUserResponse?: CurrentUserResponse;
  eventId?: string;
}

export default EventTimes;